export const FaqSection = ({ FAQ_ITEMS }) => (
  <div
    className="lil-container lil-mt-16 sm:lil-mt-12 lil-mb-12"
    itemScope
    itemType="https://schema.org/FAQPage"
  >
    <h2 className="lil-py-2 lil-text-s-56 sm:lil-text-s-32 lil-pb-5">
      Mutual Fund FAQs
    </h2>
    {FAQ_ITEMS.map((ele, index) => {
      return (
        <ul key={index}>
          <li className="lil-py-8">
            <div
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
            >
              <div
                itemProp="name"
                className="lil-font-medium lil-text-font-400 lil-text-base lil-pb-3 lil-text-s-20"
              >
                {ele.question}
              </div>
              <div
                itemScope
                itemProp="acceptedAnswer"
                itemType="https://schema.org/Answer"
              >
                <div
                  itemProp="text"
                  className="lil-text-base lil-text-grey-500 sm:lil-h-auto"
                >
                  {ele.answer}
                </div>
              </div>
            </div>
          </li>
        </ul>
      );
    })}
  </div>
);



// WEBPACK FOOTER //
// ./components/homePageNew/faqSection/faqSection.tsx